import React, { useState, useEffect } from "react";
import { getFullCompetitions } from "shared/services/api-assistant.js";

interface ControllerSeasonsProps {
  competitionName: any;
  onChange?: (competition: any, endDate: any) => void;
}

const ControllerSeasons: React.FC<ControllerSeasonsProps> = ({ competitionName, onChange }) => {
  const [competitions, setCompetitions] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [hasPrev, setHasPrev] = useState(false);
  const [hasNext, setHasNext] = useState(false);

  const fetchCompetitionHistory = () => {
    getFullCompetitions({
      handleSuccess: (v) => {
        const allCompetitions = v.data.getCompetitions.sort((a, b) => a.season - b.season);
        setCompetitions(allCompetitions);
        setSelectedIndex(allCompetitions.length - 1);
        onChange?.(allCompetitions[allCompetitions.length - 1], null);
      },
      handleError: (e) => console.log(`Error fetching standings for competition ID ${competitionName}:`, e),
      params: { name: competitionName || "Diamond League" },
    });
  };

  const getCurrentCompetition = () => competitions[selectedIndex];

  useEffect(() => {
    if (selectedIndex != null) {
      setHasPrev(selectedIndex > 0);
      setHasNext(selectedIndex < competitions.length - 1);

      if (competitions[selectedIndex]) {
        const next =
          selectedIndex < competitions.length - 1 ? competitions[selectedIndex + 1]?.startingDate ?? null : null;
        onChange?.(competitions[selectedIndex], next);
      }
    }
  }, [selectedIndex]);

  useEffect(() => {
    fetchCompetitionHistory();
  }, []);

  return (
    <div className="d-flex flex-fill align-items-center justify-content-center mb-2" style={{minWidth: 150}}>
      <button
        onClick={() => hasPrev && setSelectedIndex(selectedIndex - 1)}
        className="btn btn-sm text-main"
        disabled={!hasPrev}
      >
        <i className="bi bi-caret-left-fill"></i>
      </button>

      <span className="mx-1">{getCurrentCompetition() ? getCurrentCompetition().seasonName : "Loading..."}</span>

      <button
        onClick={() => hasNext && setSelectedIndex(selectedIndex + 1)}
        className="btn btn-sm text-main"
        disabled={!hasNext}
      >
        <i className="bi bi-caret-right-fill"></i>
      </button>
    </div>
  );
};

export default ControllerSeasons;
